import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-card-bon-commande",
	templateUrl: "./card-bon-commande.component.html",
})
export class CardBonCommandeComponent implements OnInit {
	@Input() id: string;
	@Input() numero: string;
	@Input() date: string;
	@Input() fournisseur: string;
	@Input() consultation: string;
	@Input() numeroDevis: string;
	@Input() isExporte: boolean;
	@Input() totalPriceBC: boolean;

	constructor() {}
	ngOnInit() {}
}
